import NotificationImageBell from "../../images/ic_notification_image.png";

import {
  DivNotificationBell,
  DivNotificationBellLabel,
} from "./SidebarNotificationsStyles";

export const BellNotificationComponent = (props) => {
  const { typeNotification } = props;
  return (
    <DivNotificationBell height="80vh">
      <DivNotificationBellLabel>
        <img src={NotificationImageBell} className="img-bell" alt="" />
        <DivNotificationBellLabel marginTop="4.2rem">
          <div style={{ fontWeight: 700 }}>
            Aún no has recibido notificaciones
          </div>
          <div style={{ textAlign: "center" }}>
            Podrás ver tus notificaciones de{" "}
            {typeNotification && typeNotification} en esta sección.
          </div>
        </DivNotificationBellLabel>
      </DivNotificationBellLabel>
    </DivNotificationBell>
  );
};
